import { ref, computed, watch } from 'vue'
import { getProductTypeList, getProductSiteList } from '@views/home/media/api'

const initApiMixins = (siteType: number) => {
  const productId = ref()
  const typeList = ref([])
  const siteList = ref([])
  const currentPage = ref(1)
  const pageSize = ref(6)
  const siteSelection = ref([])

  const getTypeList = async () => {
    const res = await getProductTypeList()
    typeList.value = res.data || []
  }
  const getSiteList = async () => {
    if (!productId.value) {
      siteList.value = []
      return
    }
    const res = await getProductSiteList({ siteType, productId: productId.value })
    siteList.value = res.data || []
    siteSelection.value = []
  }
  const paginatedData = computed(() => {
    const start = (currentPage.value - 1) * pageSize.value
    const end = start + pageSize.value

    // 使用 slice 进行非破坏性切分
    return siteList.value.slice(start, end)
  })
  return {
    currentPage,
    pageSize,
    siteSelection,
    productId,
    typeList,
    siteList,
    paginatedData,
    getTypeList,
    getSiteList,
  }
}
export default initApiMixins
